import { axiosInstance as request } from '@api/rest.service'

const api = '/imports/subscriptions'

/**
 * @description GET /imports/subscriptions
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTIONS_IMPORTS = () => request.get(api)

/**
 * @description GET /imports/subscriptions/create
 * @returns {AxiosPromise<any>}
 */
export const GET_CREATE_SUBSCRIPTIONS_IMPORTS = () => request.get(`${api}/create`)

/**
 * @description GET /imports/subscriptions/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTIONS_IMPORT = id => request.get(`${api}/${id}`)

/**
 * @description PUT /imports/subscriptions/preview/rows/{rowId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_SUBSCRIPTIONS_IMPORTS_ROWS = (rowId, payload) =>
  request.put(`${api}/preview/rows/${rowId}`, payload)

/**
 * @description POST /imports/subscriptions/parse
 * @returns {AxiosPromise<any>}
 */
export const PARSE_SUBSCRIPTIONS_IMPORT = payload => request.post(`${api}/parse`, payload)

/**
 * @description POST /imports/subscriptions/process
 * @returns {AxiosPromise<any>}
 */
export const PROCESS_SUBSCRIPTION_IMPORT = payload => request.post(`${api}/process`, payload)

/**
 * @description GET /imports/subscriptions/template
 * @returns {AxiosPromise<any>}
 */
export const GET_SUBSCRIPTIONS_IMPORTS_TEMPLATE = () => request.get(`${api}/template`)
